import React from 'react'

function LotViewSkeleton() {
  return (
    <div className="relative flex h-screen w-full items-center justify-center overflow-hidden bg-secondaryColour">
      <div className="skeleton"></div>

      <div className="absolute bottom-16 left-8 flex flex-col gap-4">
        <div className="skeleton h-[100px] w-[120px]"></div>
        <div className="skeleton h-[100px] w-[120px]"></div>
        <div className="skeleton h-[100px] w-[120px]"></div>
      </div>
    </div>
  )
}

export default LotViewSkeleton
